import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './ScoutSelector.css';
import Input from '../../../components/UI/Input/Input';


class ScoutSelector extends Component {
    state = {
        scoutUserId: 0,
        scoutSelected: false
    }
    constructor(props) {
        super(props);
        console.log(props)
        this.state.scoutUserId = this.props.scoutUserId;
        this.props.onDataChanged('userId',this.props.scoutUserId);
    }

    scoutSelected = ( event ) => {
        this.props.onDataChanged('userId',event.target.value);    
        this.setState({scoutUserId:event.target.value});
    }

    render () {
        let useUserId = this.state.scoutUserId;
        if (this.props.scouts) {
            let option = [,];
            
            for (let key in this.props.scouts) {
                option.push({
                    value: this.props.scouts[key].UserId,
                    displayValue: this.props.scouts[key].Scout
                });
            }

            const options = {options: option};
            return (
                <div className={classes.ScoutSelector}>
                    <Input value={useUserId} label='Scout' elementType='select' elementConfig={options} changed={(event) => this.scoutSelected(event)}></Input>
                </div>
            );
        }
    }
};

const mapStateToProps = state => {
 
    return {
        mulchYear: state.orders.mulchYear,
        scouts: state.orders.scouts
    };
}


export default connect(mapStateToProps)(ScoutSelector);


// WEBPACK FOOTER //
// ./src/components/Order/ScoutSelector/ScoutSelector.js